import SideNav from "../../components/SideNav/SideNav";
import NavBar from "../../components/NavBar/NavBar";
import { Outlet } from "react-router-dom";

const AppLayout = () => {
    return (
        <div className="app-layout">
            <NavBar />
            <SideNav />
    
            <Outlet />
        </div>
    )
}

export default AppLayout;